import { appAxiosInstance } from '@/config/axios';

import { transformKeysSnakeToCamelCase } from '@/utils/transformation';

export interface ISDiscoverableWorkspace {
	id: string;
	name: string;
	logo: string | null;
	handle: string;
	memberCount: number;
}

export interface IDiscoverWorkspacesResponse {
	pages: ISDiscoverableWorkspace[];
}

export interface IJoinWorkspaceResponse {
	id: string;
}

export const discoverWorkspaces = async (): Promise<IDiscoverWorkspacesResponse> => {
	const response = await appAxiosInstance.post('/page/discover');
	return transformKeysSnakeToCamelCase(response.data) as unknown as IDiscoverWorkspacesResponse;
};

export const joinWorkspace = async (payload: {
	page_id: string;
}): Promise<IJoinWorkspaceResponse> => {
	const response = await appAxiosInstance.post('/page/join', payload);
	return transformKeysSnakeToCamelCase(response.data) as unknown as IJoinWorkspaceResponse;
};
